import {
  Box,
  Checkbox,
  FormControlLabel,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  FormGroup,
  Skeleton,
  Tooltip,
} from "@mui/material";
import React, { useState, useEffect, useCallback } from "react";
import { CiViewColumn } from "react-icons/ci";
import FilterDrawer from "../../../../../components/FilterDrawer/FilterDrawer";
import { useSelector } from "react-redux";
import ClearFilter from "../../../../../components/ClearFilter/ClearFilter";
import FilterCheckbox from "../../../../../components/FilterDrawer/FilterCheckbox/FilterCheckbox";
import FilterSearchField from "../../../../../components/FilterDrawer/FilterSearchField/FilterSearchField";
import ShowAllBtn from "../../../../../components/FilterDrawer/ShowAll/ShowAllBtn";
import FilterChips from "../../../../../components/FilterDrawer/FilterChips/FilterChips";
import FilterLabel from "../../../../../components/FilterDrawer/FilterLabel/FilterLabel";
import FilterChipsWrap from "../../../../../components/FilterDrawer/FilterChips/FilterChipsWrap";
import FilterTypeWrap from "../../../../../components/FilterDrawer/FilterTypeWrap";
import FilterCheckBoxWrap from "../../../../../components/FilterDrawer/FilterCheckBoxWrap";
import TableSkeleton from "../../../../../components/Skeletons/TableSkeleton";
import { useAuthUser } from "react-auth-kit";
import moment from "moment";
import { useDispatch } from "react-redux";
import {
  checkSubDomainAccess,
  getSubDomainAccessStatus,
} from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import { setToastNotification } from "../../../../../components/ToastNotification/service/toastNotificationSlice";
import OpenSearch from "../../../Nurture/components/OpenSearch/OpenSearch";
import leadActiveDefault from "../../../../../assets/images/activeLeadDefault.svg";
import leadActiveIcon from "../../../../../assets/images/activeLead.svg";
import leadLostDefault from "../../../../../assets/images/lostLeadDefault.svg";
import leadLostIcon from "../../../../../assets/images/lostLead.svg";
import { setIsActiveLostTrigger } from "../../../Main/service/openSearchUpdationSlice";
import { resetDeleteEntitySuccess } from "../../../../../service/activeInstituteSlice";
import { getCustomFields } from "../../../Settings/service/settingsSlice";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { resetStudentDetails } from "../service/studentSlice";
import { openLeadExpandModal } from "../../../../../components/LeadPopup/hooks/useLeadCard";

const CustomTableCell = styled(TableCell)(({ theme }) => ({
  padding: "0px 12px",
  fontSize: "12px",
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "@media (max-width: 600px)": {
    fontSize: "12px",
  },
  "@media only screen and (min-width: 992px)": {
    fontSize: "12px",
  },
  "@media only screen and (min-width: 1200px)": {
    fontSize: "14px",
  },
}));

const CustomTableHeaderCell = styled(TableCell)(({ theme }) => ({
  padding: "16px 12px",
  fontSize: "14px",
  color: "#fff",
  background: "#073E53",
  textTransform: "capitalize",
  fontWeight: "400",
}));

interface CheckedBranch {
  id: string;
  branchName: string;
}

interface CheckedCourse {
  id: string;
  courseName: string;
}

interface CheckedBatch {
  id: string;
  batchName: string;
}

interface CheckedPaymentStatus {
  paymentStatus: string;
}

interface CheckedBatchStatus {
  batchStatus: string;
}

interface CheckedPaymentType {
  paymentType: string;
}

const paymentStatusArray = [
  {
    paymentStatus: "Fully Paid",
  },
  {
    paymentStatus: "Partly Paid",
  },
  {
    paymentStatus: "EMI Paid",
  },
  {
    paymentStatus: "EMI Due",
  },
  {
    paymentStatus: "Emi Fully Paid",
  },
  {
    paymentStatus: "Membership Fees Paid",
  },
  {
    paymentStatus: "Membership Fees Due",
  },
  {
    paymentStatus: "Membership Fully Paid",
  },
  {
    paymentStatus: "Membership Paused",
  },
];

export default function StudentListing(props: any) {
  const {
    GetStudentByInstituteId,
    studentDetails,
    studentListLoading,
    GetLeadListByInstituteAndContact,
    GetOpenSearchStudentListing,
    selectedStudent,
    defaultStudentsCall,
    setStudentsItems,
    // setLeadListItems,
    // setStudentListItems,
    // setleadPaginationLoad,
    // setStudentsStatus,
  } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch<any>();
  const loginUserBranch = authUser?.institute?.[0]?.branchId;
  const { userById } = useSelector((state: any) => state.userDetails);
  const [studentsStatusCheck, setStudentsStatusCheck] =
    React.useState<boolean>(false);
  const [studentsStatus, setStudentsStatus] = useState("ACTIVE");
  const isTriggered = useSelector(
    (state: any) => state.taskBoardUpdation?.isTriggered
  );
  const { deleteEntitySuccess, deleteEntityError } = useSelector(
    (state: any) => state.activeInstitute
  );

  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );

  const hasLeadCardPermission = checkSubDomainAccess(
    "NURTURE_BOARD",
    "LEAD_CARD",
    userById?.rolePermission
  );

  const hasSelfAssignedLeadOnly = getSubDomainAccessStatus(
    "NURTURE_BOARD",
    "LEAD_ACCESS",
    "ASSIGNED_ONLY",
    userById?.rolePermission
  );

  const {
    leadListLoading,
    createPaymentSuccess,
    recordPaymentUpdateSuccess,
    leadLostUpdateSuccess,
    leadUpdateSuccess,
    leadEmiDetailsSuccess,
    onStudentsLoading,
  } = useSelector((state: any) => state.nurture);
  const branches = useSelector((state: any) => state.branch.branchList);
  const courses = useSelector((state: any) => state.courses.courses);
  const batches = useSelector((state: any) => state.batch.batchList);
  const batchList = batches?.filter(
    (item: any) => item?.batchConductType === "REGULAR_BATCH"
  );

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [columns, setColumns] = useState([
    { id: "hash", label: "#", minWidth: 30, align: "inherit", show: true },
    {
      id: "studentId",
      label: "Student ID",
      minWidth: 140,
      align: "inherit",
      show: true,
    },
    {
      id: "name",
      label: "Student Name",
      minWidth: 170,
      align: "inherit",
      show: true,
    },
    {
      id: "status",
      label: "Batch status",
      minWidth: 30,
      align: "inherit",
      show: false,
    },
    {
      id: "courseName",
      label: "Course Name",
      minWidth: 200,
      align: "inherit",
      show: true,
    },
    {
      id: "batch",
      label: "Batch",
      minWidth: 170,
      align: "left",
      show: true,
    },
    {
      id: "branch",
      label: "Branch",
      minWidth: 180,
      align: "left",
      show: true,
    },
    {
      id: "paymentType",
      label: "Payment Type",
      minWidth: 150,
      align: "left",
      show: false,
    },
    {
      id: "paymentStatus",
      label: "Payment status",
      minWidth: 150,
      align: "left",
      show: true,
    },
    {
      id: "paymentDetails",
      label: "Payment Details",
      minWidth: 150,
      align: "left",
      show: true,
    },
  ]);

  const [studentItems, setStudentItems] = useState<any>();

  const [searchCourse, setSearchCourse] = useState<any>("");
  const [searchBatch, setSearchBatch] = useState<any>("");
  const [searchBranch, setSearchBranch] = useState<any>("");

  const [showAllCourses, setShowAllCourses] = useState<boolean>(false);
  const [showAllBatch, setShowAllBatch] = useState<boolean>(false);
  const [showAllBranches, setShowAllBranches] = useState<boolean>(false);
  const [isOpenFilter, setIsOpenFilter] = React.useState<boolean>(false);
  const [showAllPaymentStatuses, setShowAllPaymentStatuses] =
    useState<boolean>(false);

  const [filterApplied, setFilterApplied] = React.useState<boolean>(false);

  const [checkedCourses, setCheckedCourses] = useState<CheckedCourse[]>([]);
  const [filterCheckedCourses, setFilterCheckedCourses] = useState<
    CheckedCourse[]
  >([]);
  const [checkedBranches, setCheckedBranches] = useState<CheckedBranch[]>([]);
  const [filterCheckedBranches, setFilterCheckedBranches] = useState<
    CheckedBranch[]
  >([]);

  const [checkedBatches, setCheckedBatches] = useState<CheckedBatch[]>([]);
  const [filterCheckedBatches, setFilterCheckedBatches] = useState<
    CheckedBatch[]
  >([]);

  const [checkedPaymentStatus, setCheckedPaymentStatus] = useState<
    CheckedPaymentStatus[]
  >([]);
  const [filterCheckedPaymentStatus, setFilterCheckedPaymentStatus] = useState<
    CheckedPaymentStatus[]
  >([]);

  const [checkedBatchStatus, setCheckedBatchStatus] = useState<
    CheckedBatchStatus[]
  >([]);
  const [filterCheckedBatchStatus, setFilterCheckedBatchStatus] = useState<
    CheckedBatchStatus[]
  >([]);

  const [checkedPaymentType, setCheckedPaymentType] = useState<
    CheckedPaymentType[]
  >([]);
  const [filterCheckedPaymentType, setFilterCheckedPaymentType] = useState<
    CheckedPaymentType[]
  >([]);
  const [checkedTags, setCheckedTags] = useState<any>([]);
  const [filterCheckedTags, setFilterCheckedTags] = useState<any>([]);
  const isActiveLostTriggered = useSelector(
    (state: any) => state.openSearchUpdation?.isActiveLostTriggered
  );
  const [customFieldsForFilter, setCustomFieldsForFilter] = useState<any>();
  const [checkedAdditionalFilter, setCheckedAdditionalFilter] = useState<any>(
    []
  );
  const [selectAdditionalFilter, setSelectAdditionalFilter] = useState<any>([]);
  const [radioAdditionalFilter, setRadioAdditionalFilter] = useState<any>([]);
  const [
    filterForCheckedAdditionalFilter,
    setFilterForCheckedAdditionalFilter,
  ] = useState<any>([]);
  const [filterForSelectAdditionalFilter, setFilterForSelectAdditionalFilter] =
    useState<any>([]);
  const [filterForRadioAdditionalFilter, setFilterForRadioAdditionalFilter] =
    useState<any>([]);
  const [sortingOrder, setSortingOrder] = useState<any>("asc");

  const handleCourseSearch = (event: any) => {
    setSearchCourse(event.target.value);
  };
  const handleBatchSearch = (event: any) => {
    setSearchBatch(event.target.value);
  };
  const handleBranchSearch = (event: any) => {
    setSearchBranch(event.target.value);
  };

  const filteredCourses =
    courses &&
    courses?.filter((item: any) => {
      const searchTermMatch =
        item.courseName.toLowerCase().indexOf(searchCourse.toLowerCase()) !==
        -1;

      return searchTermMatch;
    });

  const displayedCourses = showAllCourses
    ? courses && filteredCourses
    : courses && filteredCourses.slice(0, 5);

  const handleShowMoreCourses = () => {
    setShowAllCourses(!showAllCourses);
  };

  const filteredBatches =
    batchList &&
    batchList
      ?.filter((item: any) =>
        !hasAllBranchAccess ? item.branchId === loginUserBranch : true
      )
      ?.filter(
        (item: any) =>
          item?.batchConductType === "REGULAR_BATCH" &&
          item?.batchStatus !== "CANCELLED" &&
          item?.status !== "INACTIVE"
      )
      ?.filter((batch: any) => {
        const searchTermMatch =
          batch.batchName.toLowerCase().indexOf(searchBatch.toLowerCase()) !==
          -1;

        return searchTermMatch;
      });

  const displayedBatches = showAllBatch
    ? batchList && filteredBatches
    : batchList && filteredBatches.slice(0, 5);

  const handleShowMoreBatches = () => {
    setShowAllBatch(!showAllBatch);
  };

  const filteredBranches =
    branches &&
    branches?.filter((branch: any) => {
      const searchTermMatch =
        branch.branchName.toLowerCase().indexOf(searchBranch.toLowerCase()) !==
        -1;

      return searchTermMatch;
    });

  const displayedBranch = showAllBranches
    ? branches && filteredBranches
    : branches && filteredBranches.slice(0, 5);

  const handleShowMoreBranches = () => {
    setShowAllBranches(!showAllBranches);
  };

  const displayedPaymentStatuses = showAllPaymentStatuses
    ? paymentStatusArray && paymentStatusArray
    : paymentStatusArray && paymentStatusArray.slice(0, 5);

  const handleShowMorePaymentStatuses = () => {
    setShowAllPaymentStatuses(!showAllPaymentStatuses);
  };

  const toggleColumn = (changeEvent: any) => {
    const { name } = changeEvent.target;
    const NewColumns = columns.map((column: any) => {
      if (column.label === name) {
        column.show = !column.show;
        return column;
      } else {
        return column;
      }
    });
    setColumns(NewColumns);
  };

  const handleFilterCourseChecked = (id: string, courseName: string) => {
    const courseToAdd: CheckedCourse = { id, courseName };
    if (checkedCourses.some((item) => item.id === id)) {
      setCheckedCourses(checkedCourses.filter((item) => item.id !== id));
    } else {
      setCheckedCourses([...checkedCourses, courseToAdd]);
    }
  };

  const clearCheckedCourse = (id: string) => {
    setCheckedCourses(checkedCourses.filter((item) => item.id !== id));
  };

  const handleFilterBranchChecked = (id: string, branchName: string) => {
    const branchToAdd: CheckedBranch = { id, branchName };
    if (checkedBranches.some((branch) => branch.id === id)) {
      setCheckedBranches(checkedBranches.filter((branch) => branch.id !== id));
    } else {
      setCheckedBranches([...checkedBranches, branchToAdd]);
    }
  };

  const clearCheckedBranch = (id: string) => {
    setCheckedBranches(checkedBranches.filter((item) => item.id !== id));
  };

  const handleFilterBatchChecked = (id: string, batchName: string) => {
    const batchToAdd: CheckedBatch = { id, batchName };
    if (checkedBatches.some((branch) => branch.id === id)) {
      setCheckedBatches(checkedBatches.filter((branch) => branch.id !== id));
    } else {
      setCheckedBatches([...checkedBatches, batchToAdd]);
    }
  };

  const clearCheckedBatch = (id: string) => {
    setCheckedBatches(checkedBatches.filter((item) => item.id !== id));
  };

  const handleFilterPaymentStatusChecked = (paymentStatus: string) => {
    const paymentStatusToAdd: CheckedPaymentStatus = { paymentStatus };

    if (
      checkedPaymentStatus.some(
        (item) =>
          item.paymentStatus.toLowerCase() === paymentStatus.toLowerCase()
      )
    ) {
      setCheckedPaymentStatus(
        checkedPaymentStatus.filter(
          (item) =>
            item.paymentStatus.toLowerCase() !== paymentStatus.toLowerCase()
        )
      );
    } else {
      setCheckedPaymentStatus([...checkedPaymentStatus, paymentStatusToAdd]);
    }
  };

  const clearCheckedPaymentStatus = (paymentStatus: string) => {
    setCheckedPaymentStatus(
      checkedPaymentStatus.filter(
        (item) => item.paymentStatus !== paymentStatus
      )
    );
  };

  const handleFilterPaymentTypeChecked = (paymentType: string) => {
    const paymentTypeToAdd: CheckedPaymentType = { paymentType };

    if (
      checkedPaymentType.some(
        (item) =>
          item.paymentType.toLowerCase().replace(/_/g, " ") ===
          paymentType.toLowerCase().replace(/_/g, " ")
      )
    ) {
      setCheckedPaymentType(
        checkedPaymentType.filter(
          (item) =>
            item.paymentType.toLowerCase().replace(/_/g, " ") !==
            paymentType.toLowerCase().replace(/_/g, " ")
        )
      );
    } else {
      setCheckedPaymentType([...checkedPaymentType, paymentTypeToAdd]);
    }
  };

  const clearCheckedPaymentType = (paymentType: string) => {
    setCheckedPaymentType(
      checkedPaymentType.filter((item) => item.paymentType !== paymentType)
    );
  };

  const handleFilterBatchStatusChecked = (batchStatus: string) => {
    const batchStatusToAdd: CheckedBatchStatus = { batchStatus };

    if (
      checkedBatchStatus.some(
        (item) => item.batchStatus.toLowerCase() === batchStatus.toLowerCase()
      )
    ) {
      setCheckedBatchStatus(
        checkedBatchStatus.filter(
          (item) => item.batchStatus.toLowerCase() !== batchStatus.toLowerCase()
        )
      );
    } else {
      setCheckedBatchStatus([...checkedBatchStatus, batchStatusToAdd]);
    }
  };

  const clearCheckedBatchStatus = (batchStatus: string) => {
    setCheckedBatchStatus(
      checkedBatchStatus.filter((item) => item.batchStatus !== batchStatus)
    );
  };

  const mergeFilters = (filterGroups: any[][]) => {
    const mergedMap: Record<string, Set<string>> = {};

    filterGroups.flat().forEach(({ key, value }) => {
      if (!mergedMap[key]) {
        mergedMap[key] = new Set(value);
      } else {
        value.forEach((v: string) => mergedMap[key].add(v));
      }
    });

    return Object.entries(mergedMap).map(([key, valSet]) => ({
      key,
      value: Array.from(valSet),
    }));
  };

  const studentListApiCall = useCallback(
    (
      batchStatus: any,
      paymentType: any,
      paymentStatus: any,
      coursesArray: any,
      branchesArray: any,
      batchesArray: any,
      enquiryStatus: any,
      tagsArray: any,
      checkboxAdditionalParams: any,
      selectAdditionalParams: any,
      radioAdditionalParams: any,
      sortKey?: string,
      sortType?: any
    ) => {
      const userFromLocalStorage = authUser?.institute?.[0]?.instituteDetails;
      const branchId = hasAllBranchAccess
        ? "All"
        : authUser?.institute?.[0]?.branchId;

      const assigneeId = hasSelfAssignedLeadOnly
        ? authUser?.institute?.[0]?.id
        : "";

      const urlSearchParams = new URLSearchParams(window.location.search);

      const sortingOrder = urlSearchParams.get("sortingOrder");

      const body = {
        entityName: "BATCHSTUDENTMAPPING",
        instituteId: userFromLocalStorage?.id,
        isFilter: true,
        searchText: "",
        enquiryAssignedToId: assigneeId,
        batchStatus:
          batchStatus?.length > 0
            ? batchStatus.map((item: any) => item?.batchStatus?.toUpperCase())
            : [],
        paymentType:
          paymentType?.length > 0
            ? paymentType.map((item: any) => item?.paymentType?.toUpperCase())
            : [],
        paymentStatus:
          paymentStatus?.length > 0
            ? paymentStatus.map((item: any) => item?.paymentStatus)
            : [],
        courseId:
          coursesArray?.length > 0
            ? coursesArray.map((item: any) => item?.id)
            : [],
        // branchId:
        // branchId === "All"
        // ? branchesArray?.length > 0
        // ? branchesArray.map((item: any) => item?.id)
        // : []
        // : [branchId],
        branchId: !hasAllBranchAccess
          ? [userById?.branchId]
          : branchesArray?.length > 0
          ? branchesArray.map((item: any) => item?.id)
          : [],
        batchId:
          batchesArray?.length > 0
            ? batchesArray.map((item: any) => item?.id)
            : [],
        enquiryStatus: enquiryStatus,
        enquiryProfileTag:
          tagsArray?.length > 0
            ? tagsArray?.map((item: any) =>
                item?.value === "Select"
                  ? "SELECT"
                  : item?.value === "Cold"
                  ? "COLD"
                  : item?.value === "Warm"
                  ? "WARM"
                  : item?.value === "Hot"
                  ? "HOT"
                  : item?.value === "Interested"
                  ? "INTERESTED"
                  : item?.value === "Followup"
                  ? "FOLLOWUP"
                  : item?.value === "Invalid"
                  ? "INVALID"
                  : item?.value === "Disqualified"
                  ? "DISQUALIFIED"
                  : item?.value === "Not Answering"
                  ? "NOT_ANSWERING"
                  : item?.value === "Not Interested"
                  ? "NOT_INTERESTED"
                  : item?.value === "Future Prospect"
                  ? "FUTURE_PROSPECT"
                  : item?.value === "Budget Constraint"
                  ? "BUDGET_CONSTRAINT"
                  : item?.value === "Not Reachable"
                  ? "NOT_REACHABLE"
                  : item?.value === "Lost"
                  ? "LOST"
                  : item?.value === "Shortlisted"
                  ? "SHORTLISTED"
                  : item?.value === "Admission"
                  ? "ADMISSION"
                  : item?.value === "Exam Schedule"
                  ? "EXAM_SCHEDULE"
                  : item?.value === "Qualified"
                  ? "QUALIFIED"
                  : item?.value === "Placement Done"
                  ? "PLACEMENT_DONE"
                  : item?.value === "Flexi Payment Plan"
                  ? "FLEXI_PAYMENT_PLAN"
                  : item?.value === "Call Back"
                  ? "CALL_BACK"
                  : item?.value === "Discontinued"
                  ? "DISCONTINUED"
                  : item?.value === "Discontinued and Refunded"
                  ? "DISCONTINUED_REFUNDED"
                  : ""
              )
            : [],
        additionalFilters: mergeFilters([
          checkboxAdditionalParams,
          selectAdditionalParams,
          radioAdditionalParams,
        ]),
        sortKey: sortKey ? sortKey : "",
        sortType: sortingOrder ? sortingOrder : sortType,
      };

      if (userFromLocalStorage) {
        GetOpenSearchStudentListing(body);
      }
    },
    [authUser, userById, hasAllBranchAccess]
  );

  const handleFilterStudents = React.useCallback(
    (
      batchStatusArray: any,
      paymentStatusArray: any,
      branchArray: any,
      courseArray: any,
      batchArray: any,
      paymentTypeArray: any,
      tagsArray: any,
      checkedAdditionalFilter: any,
      selectAdditionalFilter: any,
      radioAdditionalFilter: any
    ) => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const studentsStatusParam = urlSearchParams.get("studentsStatus");
      setFilterCheckedCourses(courseArray);
      setFilterCheckedBranches(branchArray);
      setFilterCheckedBatches(batchArray);
      setFilterCheckedPaymentStatus(paymentStatusArray);
      setFilterCheckedBatchStatus(batchStatusArray);
      setFilterCheckedPaymentType(paymentTypeArray);
      setFilterCheckedTags(tagsArray);

      setFilterForCheckedAdditionalFilter(checkedAdditionalFilter);
      setFilterForSelectAdditionalFilter(selectAdditionalFilter);
      setFilterForRadioAdditionalFilter(radioAdditionalFilter);

      studentListApiCall(
        batchStatusArray,
        paymentTypeArray,
        paymentStatusArray,
        courseArray,
        branchArray,
        batchArray,
        studentsStatusParam ? studentsStatusParam : studentsStatus,
        tagsArray,
        checkedAdditionalFilter,
        selectAdditionalFilter,
        radioAdditionalFilter
      );
      const queryParams = new URLSearchParams(window.location.search);

      if (branchArray && branchArray?.length > 0) {
        const branchParam = branchArray
          ?.map((branch: any) => branch.id)
          .join("|");
        queryParams.set("filteredBranches", branchParam);
      } else {
        queryParams.delete("filteredBranches");
      }

      if (batchArray && batchArray?.length > 0) {
        const batchParam = batchArray?.map((item: any) => item.id).join("|");
        queryParams.set("filteredBatches", batchParam);
      } else {
        queryParams.delete("filteredBatches");
      }
      if (courseArray && courseArray?.length > 0) {
        const courseParam = courseArray?.map((item: any) => item.id).join("|");
        queryParams.set("filteredCourses", courseParam);
      } else {
        queryParams.delete("filteredCourses");
      }
      if (batchStatusArray && batchStatusArray?.length > 0) {
        const batchStatusParam = batchStatusArray
          ?.map((item: any) => item.batchStatus)
          .join("|");
        queryParams.set("filteredBatchStatus", batchStatusParam);
      } else {
        queryParams.delete("filteredBatchStatus");
      }

      if (paymentStatusArray && paymentStatusArray?.length > 0) {
        const paymentStatusParam = paymentStatusArray
          ?.map((item: any) => item.paymentStatus)
          .join("|");
        queryParams.set("filteredPaymentStatus", paymentStatusParam);
      } else {
        queryParams.delete("filteredPaymentStatus");
      }

      if (paymentTypeArray && paymentTypeArray?.length > 0) {
        const paymentTypeParam = paymentTypeArray
          ?.map((item: any) => item.paymentType?.toUpperCase())
          .join("|");
        queryParams.set("filteredPaymentType", paymentTypeParam);
      } else {
        queryParams.delete("filteredPaymentType");
      }

      if (tagsArray && tagsArray.length > 0) {
        const sourceParam = tagsArray.map((item: any) => item.value).join("|");
        queryParams.set("filteredTags", sourceParam);
      } else {
        queryParams.delete("filteredTags");
      }

      if (checkedAdditionalFilter && checkedAdditionalFilter?.length > 0) {
        checkedAdditionalFilter.forEach((filter: any) => {
          if (filter.key && filter.value?.length > 0) {
            queryParams.set(filter.key, filter.value.join(","));
          } else {
            queryParams.delete(filter.key);
          }
        });
      } else {
        urlSearchParams.forEach((value, key) => {
          const predefinedKeys = [
            "filteredBranches",
            "filteredBatches",
            "filteredCourses",
            "filteredPaymentType",
            "filteredPaymentStatus",
            "filteredBatchStatus",
            "filteredTags",
          ];

          if (!predefinedKeys.includes(key)) {
            queryParams.delete(key);
          }
        });
      }

      if (selectAdditionalFilter && selectAdditionalFilter?.length > 0) {
        selectAdditionalFilter.forEach((filter: any) => {
          if (filter.key && filter.value?.length > 0) {
            queryParams.set(filter.key, filter.value.join(","));
          } else {
            queryParams.delete(filter.key);
          }
        });
      } else {
        urlSearchParams.forEach((value, key) => {
          const predefinedKeys = [
            "filteredBranches",
            "filteredBatches",
            "filteredCourses",
            "filteredPaymentType",
            "filteredPaymentStatus",
            "filteredBatchStatus",
            "filteredTags",
          ];

          if (!predefinedKeys.includes(key)) {
            queryParams.delete(key);
          }
        });
      }

      if (radioAdditionalFilter && radioAdditionalFilter?.length > 0) {
        radioAdditionalFilter.forEach((filter: any) => {
          if (filter.key && filter.value?.length > 0) {
            queryParams.set(filter.key, filter.value.join(","));
          } else {
            queryParams.delete(filter.key);
          }
        });
      } else {
        urlSearchParams.forEach((value, key) => {
          const predefinedKeys = [
            "filteredBranches",
            "filteredBatches",
            "filteredCourses",
            "filteredPaymentType",
            "filteredPaymentStatus",
            "filteredBatchStatus",
            "filteredTags",
          ];

          if (!predefinedKeys.includes(key)) {
            queryParams.delete(key);
          }
        });
      }

      const queryString = queryParams.toString();
      const newUrl = `${window.location.pathname}${
        queryString ? `?${queryString}` : ""
      }`;

      window.history.pushState({}, "", newUrl);
    },
    [
      setFilterCheckedCourses,
      setFilterCheckedBranches,
      setFilterCheckedBatches,
      setFilterCheckedPaymentStatus,
      setFilterCheckedBatchStatus,
      setFilterCheckedPaymentType,
      setFilterCheckedTags,
      setFilterForCheckedAdditionalFilter,
      setFilterForSelectAdditionalFilter,
      setFilterForRadioAdditionalFilter,
    ]
  );

  const handleFilterApply = React.useCallback(() => {
    handleFilterStudents(
      checkedBatchStatus,
      checkedPaymentStatus,
      checkedBranches,
      checkedCourses,
      checkedBatches,
      checkedPaymentType,
      checkedTags,
      checkedAdditionalFilter,
      selectAdditionalFilter,
      radioAdditionalFilter
    );

    setFilterApplied(
      checkedBatchStatus?.length === 0 &&
        checkedPaymentStatus?.length === 0 &&
        checkedBranches?.length === 0 &&
        checkedCourses?.length === 0 &&
        checkedBatches?.length === 0 &&
        checkedPaymentType?.length === 0 &&
        checkedTags?.length === 0 &&
        checkedAdditionalFilter?.length === 0 &&
        selectAdditionalFilter?.length === 0 &&
        radioAdditionalFilter?.length === 0
        ? false
        : true
    );
  }, [
    handleFilterStudents,
    setFilterApplied,
    checkedPaymentStatus,
    checkedBranches,
    checkedCourses,
    checkedBatches,
    checkedBatchStatus,
    checkedPaymentType,
    checkedTags,
    checkedAdditionalFilter,
    selectAdditionalFilter,
    radioAdditionalFilter,
  ]);

  const handleResetClick = React.useCallback(() => {
    setFilterApplied(false);
    setCheckedBranches([]);
    setCheckedCourses([]);
    setCheckedBatches([]);
    setCheckedBatchStatus([]);
    setCheckedPaymentStatus([]);
    setCheckedPaymentType([]);
    handleFilterStudents([], [], [], [], [], [], [], [], [], []);
    setFilterCheckedBranches([]);
    setFilterCheckedCourses([]);
    setFilterCheckedBatchStatus([]);
    setFilterCheckedPaymentStatus([]);
    setFilterCheckedBatches([]);
    setFilterCheckedPaymentType([]);
    setCheckedTags([]);
    setFilterCheckedTags([]);
    setCheckedAdditionalFilter([]);
    setRadioAdditionalFilter([]);
    setSelectAdditionalFilter([]);
    setFilterForCheckedAdditionalFilter([]);
    setFilterForSelectAdditionalFilter([]);
    setFilterForRadioAdditionalFilter([]);
  }, [
    setFilterApplied,
    setCheckedBranches,
    setCheckedCourses,
    setCheckedBatches,
    setCheckedBatchStatus,
    setCheckedPaymentStatus,
    setCheckedPaymentType,
    setCheckedCourses,
    setFilterCheckedBranches,
    setFilterCheckedCourses,
    setFilterCheckedBatchStatus,
    setFilterCheckedPaymentStatus,
    setFilterCheckedBatches,
    setFilterCheckedPaymentType,
    setCheckedTags,
    setFilterCheckedTags,
    setSelectAdditionalFilter,
    setCheckedAdditionalFilter,
    setRadioAdditionalFilter,
    setFilterForCheckedAdditionalFilter,
    setFilterForSelectAdditionalFilter,
    setFilterForRadioAdditionalFilter,
  ]);

  const handleFilterClose = React.useCallback(() => {
    setCheckedBranches(filterCheckedBranches);
    setCheckedBatchStatus(filterCheckedBatchStatus);
    setCheckedCourses(filterCheckedCourses);
    setCheckedPaymentStatus(filterCheckedPaymentStatus);
    setCheckedPaymentType(filterCheckedPaymentType);
    setCheckedBatches(filterCheckedBatches);
    setCheckedTags(filterCheckedTags);
    setCheckedAdditionalFilter(filterForCheckedAdditionalFilter);
    setSelectAdditionalFilter(filterForSelectAdditionalFilter);
    setRadioAdditionalFilter(filterForRadioAdditionalFilter);
  }, [
    filterCheckedBranches,
    filterCheckedCourses,
    filterCheckedPaymentType,
    filterCheckedBatchStatus,
    filterCheckedPaymentStatus,
    filterCheckedBatches,
    filterCheckedTags,
    filterForCheckedAdditionalFilter,
    filterForSelectAdditionalFilter,
    filterForRadioAdditionalFilter,
  ]);

  const filteredValue = (
    <>
      {filterCheckedBranches?.length > 0 &&
        filterCheckedBranches?.map((item) => (
          <div key={item.id} className="filteredDiv">
            {item.branchName}
          </div>
        ))}
      {filterCheckedCourses?.length > 0 &&
        filterCheckedCourses?.map((item) => (
          <div key={item.id} className="filteredDiv">
            {item.courseName}
          </div>
        ))}
      {filterCheckedBatches?.length > 0 &&
        filterCheckedBatches?.map((item) => (
          <div key={item.id} className="filteredDiv">
            {item.batchName}
          </div>
        ))}
      {filterCheckedBatchStatus?.length > 0 &&
        filterCheckedBatchStatus?.map((item) => (
          <div key={item?.batchStatus} className="filteredDiv">
            {item?.batchStatus?.toLowerCase()}
          </div>
        ))}
      {filterCheckedPaymentStatus?.length > 0 &&
        filterCheckedPaymentStatus?.map((item) => (
          <div key={item.paymentStatus} className="filteredDiv">
            {item.paymentStatus}
          </div>
        ))}
      {filterCheckedPaymentType?.length > 0 &&
        filterCheckedPaymentType?.map((item) => (
          <div key={item.paymentType} className="filteredDiv">
            {item.paymentType}
          </div>
        ))}
      {filterCheckedTags?.length > 0 &&
        filterCheckedTags?.map((item: any) => (
          <div key={item.value} className="filteredDiv">
            {item.value?.toLowerCase()}
          </div>
        ))}
      {filterForCheckedAdditionalFilter?.length > 0 &&
        filterForCheckedAdditionalFilter.flatMap((item: any) =>
          item.value.map((val: string) => (
            <div key={`${item.key}-${val}`} className="filteredDiv">
              {`${val}`.toLowerCase()}
            </div>
          ))
        )}
      {filterForSelectAdditionalFilter?.length > 0 &&
        filterForSelectAdditionalFilter.flatMap((item: any) =>
          item.value.map((val: string) => (
            <div key={`${item.key}-${val}`} className="filteredDiv">
              {`${val}`.toLowerCase()}
            </div>
          ))
        )}
      {filterForRadioAdditionalFilter?.length > 0 &&
        filterForRadioAdditionalFilter.flatMap((item: any) =>
          item.value.map((val: string) => (
            <div key={`${item.key}-${val}`} className="filteredDiv">
              {`${val}`.toLowerCase()}
            </div>
          ))
        )}
    </>
  );

  const cancelClick = () => {
    setIsOpenFilter(true);
  };

  const closeClearFilter = () => {
    setIsOpenFilter(false);
  };

  const yesButtonClick = () => {
    handleResetClick();
    setIsOpenFilter(false);
  };

  const noButtonClick = () => {
    setIsOpenFilter(false);
  };

  const leadPopupApiCall = useCallback(
    (instituteId: string, phone: string | null, email: string | null) => {
      let data: any;
      if (instituteId) {
        if (phone) {
          data = {
            id: instituteId,
            phone: phone,
          };
          GetLeadListByInstituteAndContact(data);
        } else if (email) {
          data = {
            id: instituteId,
            email: email,
          };
          GetLeadListByInstituteAndContact(data);
        }
      }
    },
    [GetLeadListByInstituteAndContact]
  );

  const instituteFromLocalStorage = JSON.parse(
    localStorage.getItem("ACTIVE_INSTITUTE")!
  );

  const { customFields } = useSelector((state: any) => state.appSettings);

  // useEffect(() => {
  //   if (instituteFromLocalStorage?.id) {
  //     dispatch(getCustomFields(instituteFromLocalStorage?.id));
  //   }
  // }, []);

  useEffect(() => {
    if (customFields) {
      const fields = customFields?.fields
        ?.map((field: any) => {
          if (
            field?.field?.fieldType === "radio" ||
            field?.field?.fieldType === "select" ||
            field?.field?.fieldType === "checkbox"
          ) {
            return field?.field;
          }
        })
        ?.filter((d: any) => d !== undefined);
      setCustomFieldsForFilter(fields);
    }
  }, [customFields]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const branchParam = urlSearchParams.get("filteredBranches");
    const batchParam = urlSearchParams.get("filteredBatches");
    const courseParam = urlSearchParams.get("filteredCourses");
    const paymentTypeParam = urlSearchParams.get("filteredPaymentType");
    const paymentStatusParam = urlSearchParams.get("filteredPaymentStatus");
    const batchStatusParam = urlSearchParams.get("filteredBatchStatus");
    const tagsParam = urlSearchParams.get("filteredTags");
    const sortingOrder = urlSearchParams.get("sortingOrder");

    const batchStatusInUrl = batchStatusParam
      ? batchStatusParam.split("|").map((item: string) => ({
          batchStatus: item,
        }))
      : [];
    const paymentTypeInUrl = paymentTypeParam
      ? paymentTypeParam.split("|").map((item: string) => ({
          paymentType: item,
        }))
      : [];
    const paymentStatusInUrl = paymentStatusParam
      ? paymentStatusParam.split("|").map((item: string) => ({
          paymentStatus: item,
        }))
      : [];
    const courseIdInUrl = courseParam
      ? courseParam.split("|").map((item: string) => ({
          id: item,
        }))
      : [];
    const branchIdInUrl = branchParam
      ? branchParam.split("|").map((item: string) => ({
          id: item,
        }))
      : [];
    const batchIdInUrl = batchParam
      ? batchParam.split("|").map((item: string) => ({ id: item }))
      : [];

    const tagStatusInUrl = tagsParam
      ? tagsParam.split("|").map((item: string) => ({
          value: item,
        }))
      : [];

    if (branchParam && branches) {
      const branchIds = branchParam.split("|");

      const selectedBranches = branchIds
        .map((id) => {
          const branch = branches?.find((branch: any) => branch.id === id);
          return branch ? { id, branchName: branch.branchName } : null;
        })
        .filter(Boolean) as CheckedBranch[];

      setFilterCheckedBranches(selectedBranches);
      setCheckedBranches(selectedBranches);
    }

    if (batchParam && batchList) {
      const batchIds = batchParam.split("|");

      const selectedBatches = batchIds
        .map((id) => {
          const batch = batchList?.find((batch: any) => batch.id === id);
          return batch ? { id, batchName: batch.batchName } : null;
        })
        .filter(Boolean) as CheckedBatch[];

      setFilterCheckedBatches(selectedBatches);
      setCheckedBatches(selectedBatches);
    }

    if (courseParam && courses) {
      const courseIds = courseParam.split("|");

      const selectedCourses = courseIds
        .map((id) => {
          const course = courses?.find((course: any) => course.id === id);
          return course ? { id, courseName: course.courseName } : null;
        })
        .filter(Boolean) as CheckedCourse[];

      setFilterCheckedCourses(selectedCourses);
      setCheckedCourses(selectedCourses);
    }

    if (paymentTypeParam) {
      const paymentTypes = paymentTypeParam.split("|");

      const selectedPaymentTypes = paymentTypes
        .map((value) => {
          const paymentTypes = [
            { paymentType: "ACTIVE" },
            { paymentType: "LOST" },
          ].find(
            (type: any) =>
              type.paymentType.toLowerCase() === value.toLowerCase()
          );
          return paymentTypes
            ? {
                paymentType: paymentTypes.paymentType,
              }
            : null;
        })
        .filter(Boolean) as CheckedPaymentType[];

      setFilterCheckedPaymentType(selectedPaymentTypes);
      setCheckedPaymentType(selectedPaymentTypes);
    }

    if (batchStatusParam) {
      const batchStatus = batchStatusParam.split("|");

      const selectedBatchStatuses = batchStatus
        .map((value) => {
          const batchStatuses = [
            { batchStatus: "ONGOING" },
            { batchStatus: "UPCOMING" },
            { batchStatus: "CANCELLED" },
            { batchStatus: "COMPLETED" },
          ].find(
            (type: any) =>
              type.batchStatus.toLowerCase() === value.toLowerCase()
          );
          return batchStatuses
            ? {
                batchStatus: batchStatuses.batchStatus,
              }
            : null;
        })
        .filter(Boolean) as CheckedBatchStatus[];

      setFilterCheckedBatchStatus(selectedBatchStatuses);
      setCheckedBatchStatus(selectedBatchStatuses);
    }

    if (paymentStatusParam) {
      const paymentStatus = paymentStatusParam.split("|");

      const selectedPaymentStatuses = paymentStatus
        .map((value) => {
          const foundStatus = paymentStatusArray.find(
            (type) => type.paymentStatus === value
          );
          return foundStatus
            ? { paymentStatus: foundStatus.paymentStatus }
            : null;
        })
        .filter(Boolean) as CheckedPaymentStatus[];

      setFilterCheckedPaymentStatus(selectedPaymentStatuses);
      setCheckedPaymentStatus(selectedPaymentStatuses);
    }

    if (tagsParam) {
      const tagStatus = tagsParam.split("|");

      const selectedTagStatuses = tagStatus
        .map((value) => {
          const tagStatuses = [
            { id: 0, value: "Select" },
            { id: 1, value: "Cold" },
            { id: 2, value: "Warm" },
            { id: 3, value: "Hot" },
            { id: 4, value: "Interested" },
            { id: 5, value: "Followup" },
            { id: 6, value: "Invalid" },
            { id: 7, value: "Disqualified" },
            { id: 8, value: "Not Answering" },
            { id: 9, value: "Not Interested" },
            { id: 10, value: "Future Prospect" },
            { id: 11, value: "Budget Constraint" },
            { id: 12, value: "Not Reachable" },
            { id: 13, value: "Lost" },
            { id: 14, value: "Shortlisted" },
            { id: 15, value: "Admission" },
            { id: 16, value: "Exam Schedule" },
            { id: 17, value: "Qualified" },
            { id: 18, value: "Placement Done" },
            { id: 19, value: "Flexi Payment Plan" },
            { id: 20, value: "Call Back" },
            { id: 21, value: "Discontinued" },
            { id: 22, value: "Discontinued and Refunded" },
          ].find(
            (type: any) => type.value.toLowerCase() === value.toLowerCase()
          );
          return tagStatuses
            ? {
                id: tagStatuses.id,
                value: tagStatuses.value,
              }
            : null;
        })
        .filter(Boolean) as any[];
      setFilterCheckedTags(selectedTagStatuses);
      setCheckedTags(selectedTagStatuses);
    }

    const dynamicChecked: any[] = [];
    const dynamicSelect: any[] = [];
    const dynamicRadio: any[] = [];

    urlSearchParams.forEach((value, key) => {
      const predefinedKeys = [
        "filteredBranches",
        "filteredBatches",
        "filteredCourses",
        "filteredPaymentType",
        "filteredPaymentStatus",
        "filteredBatchStatus",
        "filteredTags",
      ];

      if (!predefinedKeys.includes(key)) {
        const fieldMeta = customFields?.fields
          ?.map((field: any) => {
            if (
              field?.field?.fieldType === "radio" ||
              field?.field?.fieldType === "select" ||
              field?.field?.fieldType === "checkbox"
            ) {
              return field?.field;
            }
          })
          ?.filter((d: any) => d !== undefined)
          ?.find((f: any) => f.fieldName === key);

        if (fieldMeta) {
          const parsedValue = value.split(",");
          const entry = { key, value: parsedValue };

          if (fieldMeta.fieldType === "checkbox") {
            dynamicChecked.push(entry);
          } else if (fieldMeta.fieldType === "select") {
            dynamicSelect.push(entry);
          } else if (fieldMeta.fieldType === "radio") {
            dynamicRadio.push(entry);
          }
        }
      }
    });

    setCheckedAdditionalFilter(dynamicChecked);
    setSelectAdditionalFilter(dynamicSelect);
    setRadioAdditionalFilter(dynamicRadio);
    setFilterForCheckedAdditionalFilter(dynamicChecked);
    setFilterForSelectAdditionalFilter(dynamicSelect);
    setFilterForRadioAdditionalFilter(dynamicRadio);
    if (customFields) {
      studentListApiCall(
        batchStatusInUrl,
        paymentTypeInUrl,
        paymentStatusInUrl,
        courseIdInUrl,
        branchIdInUrl,
        batchIdInUrl,
        studentsStatus,
        tagStatusInUrl,
        dynamicChecked,
        dynamicSelect,
        dynamicRadio,
        "studentId",
        sortingOrder
      );
    }
    setSortingOrder(sortingOrder);
    if (
      branchParam ||
      batchParam ||
      courseParam ||
      paymentTypeParam ||
      batchStatusParam ||
      paymentStatusParam ||
      tagsParam ||
      dynamicChecked?.length > 0 ||
      dynamicSelect?.length > 0 ||
      dynamicRadio?.length > 0
    ) {
      setFilterApplied(true);
    }
  }, [studentsStatus, isTriggered, customFields]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const modalDisplay = urlSearchParams.get("leadModal");
    const leadInstituteId = urlSearchParams.get("leadInstituteId");
    const leadPhone = urlSearchParams.get("leadPhone");
    const leadEmail = urlSearchParams.get("leadEmail");

    if (modalDisplay === "true" && leadListLoading === false) {
      if (leadInstituteId) {
        if (leadPhone || leadEmail) {
          leadPopupApiCall(leadInstituteId, leadPhone, leadEmail);
        }
      }
    }
  }, []);

  React.useEffect(() => {
    setStudentItems(studentDetails);
  }, [studentDetails]);

  React.useEffect(() => {
    if (
      (createPaymentSuccess !== true && createPaymentSuccess !== false) ||
      (recordPaymentUpdateSuccess !== true &&
        recordPaymentUpdateSuccess !== false) ||
      (leadLostUpdateSuccess !== true && leadLostUpdateSuccess !== false) ||
      (leadUpdateSuccess !== true && leadUpdateSuccess !== false) ||
      (leadEmiDetailsSuccess !== true && leadEmiDetailsSuccess !== false) ||
      deleteEntitySuccess === true
    ) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const branchParam = urlSearchParams.get("filteredBranches");
      const batchParam = urlSearchParams.get("filteredBatches");
      const courseParam = urlSearchParams.get("filteredCourses");
      const paymentTypeParam = urlSearchParams.get("filteredPaymentType");
      const paymentStatusParam = urlSearchParams.get("filteredPaymentStatus");
      const batchStatusParam = urlSearchParams.get("filteredBatchStatus");
      const tagsParam = urlSearchParams.get("filteredTags");
      const sortingOrder = urlSearchParams.get("sortingOrder");

      const batchStatusInUrl = batchStatusParam
        ? batchStatusParam.split("|").map((item: string) => ({
            batchStatus: item,
          }))
        : [];
      const paymentTypeInUrl = paymentTypeParam
        ? paymentTypeParam.split("|").map((item: string) => ({
            paymentType: item,
          }))
        : [];
      const paymentStatusInUrl = paymentStatusParam
        ? paymentStatusParam.split("|").map((item: string) => ({
            paymentStatus: item,
          }))
        : [];
      const courseIdInUrl = courseParam
        ? courseParam.split("|").map((item: string) => ({
            id: item,
          }))
        : [];
      const branchIdInUrl = branchParam
        ? branchParam.split("|").map((item: string) => ({
            id: item,
          }))
        : [];
      const batchIdInUrl = batchParam
        ? batchParam.split("|").map((item: string) => ({ id: item }))
        : [];

      const tagStatusInUrl = tagsParam
        ? tagsParam.split("|").map((item: string) => ({
            value: item,
          }))
        : [];

      const dynamicChecked: any[] = [];
      const dynamicSelect: any[] = [];
      const dynamicRadio: any[] = [];

      urlSearchParams.forEach((value, key) => {
        const predefinedKeys = [
          "filteredBranches",
          "filteredBatches",
          "filteredCourses",
          "filteredPaymentType",
          "filteredPaymentStatus",
          "filteredBatchStatus",
          "filteredTags",
        ];

        if (!predefinedKeys.includes(key)) {
          const fieldMeta = customFieldsForFilter?.find(
            (f: any) => f.fieldName === key
          );

          if (fieldMeta) {
            const parsedValue = value.split(",");
            const entry = { key, value: parsedValue };

            if (fieldMeta.fieldType === "checkbox") {
              dynamicChecked.push(entry);
            } else if (fieldMeta.fieldType === "select") {
              dynamicSelect.push(entry);
            } else if (fieldMeta.fieldType === "radio") {
              dynamicRadio.push(entry);
            }
          }
        }
      });

      setCheckedAdditionalFilter(dynamicChecked);
      setSelectAdditionalFilter(dynamicSelect);
      setRadioAdditionalFilter(dynamicRadio);
      setFilterForCheckedAdditionalFilter(dynamicChecked);
      setFilterForSelectAdditionalFilter(dynamicSelect);
      setFilterForRadioAdditionalFilter(dynamicRadio);

      studentListApiCall(
        batchStatusInUrl,
        paymentTypeInUrl,
        paymentStatusInUrl,
        courseIdInUrl,
        branchIdInUrl,
        batchIdInUrl,
        studentsStatus,
        tagStatusInUrl,
        dynamicChecked,
        dynamicSelect,
        dynamicRadio,
        "studentId",
        sortingOrder
      );
    }
  }, [
    createPaymentSuccess,
    recordPaymentUpdateSuccess,
    leadUpdateSuccess,
    leadLostUpdateSuccess,
    leadEmiDetailsSuccess,
    deleteEntitySuccess,
  ]);

  useEffect(() => {
    if (deleteEntitySuccess || deleteEntityError) {
      dispatch(resetDeleteEntitySuccess());
    }
  }, [deleteEntitySuccess, deleteEntityError]);

  // const allBranches = useSelector((state: any) => state.branch);

  const handleSelectCurrency = (id: string) => {
    if (id !== "") {
      const currency = branches
        ?.filter((branch: any) => branch.id == id)
        ?.map((item: any) => item.currency);
      return currency && currency[0] ? currency[0] : "₹";
    } else return "₹";
  };

  const handleStudentStatusChange = useCallback(
    (event: any, studentId: string) => {
      const value = event;
      setStudentsStatusCheck(value);
      dispatch(resetStudentDetails());

      if (value) {
        setStudentsStatus("LOST");
      } else {
        setStudentsStatus("ACTIVE");
      }

      const queryParams = new URLSearchParams(window.location.search);
      if (value === true) {
        queryParams.set("studentsStatus", "LOST");
      } else {
        queryParams.delete("studentsStatus");
      }

      const queryString = queryParams.toString();
      const newUrl = `${window.location.pathname}${
        queryString ? `?${queryString}` : ""
      }`;

      window.history.pushState({}, "", newUrl);
    },
    []
  );

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const studentsStatusParam = urlSearchParams.get("studentsStatus");

    if (studentsStatusParam === "LOST") {
      setStudentsStatus("LOST");
      setStudentsStatusCheck(true);
    } else if (studentsStatusParam === "ACTIVE") {
      setStudentsStatus("ACTIVE");
      setStudentsStatusCheck(false);
    }
  }, []);

  const handleFilterTagsChecked = (value: any) => {
    const priorityToAdd: any = { value };

    if (
      checkedTags.some(
        (item: any) => item.value.toLowerCase() === value.toLowerCase()
      )
    ) {
      setCheckedTags(
        checkedTags.filter(
          (item: any) => item.value.toLowerCase() !== value.toLowerCase()
        )
      );
    } else {
      setCheckedTags([...checkedTags, priorityToAdd]);
    }
  };

  const clearCheckedTag = (value: any) => {
    setCheckedTags(
      checkedTags.filter(
        (item: any) => item.value.toLowerCase() !== value.toLowerCase()
      )
    );
  };

  const handleAdditionalFilterChecked = (key: string, value: string) => {
    setCheckedAdditionalFilter((prev: any) => {
      const existing = prev.find((item: any) => item.key === key);
      if (existing) {
        const existsInValue = existing.value.includes(value);
        if (existsInValue) {
          const updatedValue = existing.value.filter((v: any) => v !== value);
          if (updatedValue.length === 0) {
            return prev.filter((item: any) => item.key !== key); // remove entire group
          } else {
            return prev.map((item: any) =>
              item.key === key ? { ...item, value: updatedValue } : item
            );
          }
        } else {
          return prev.map((item: any) =>
            item.key === key ? { ...item, value: [...item.value, value] } : item
          );
        }
      } else {
        return [...prev, { key, value: [value] }];
      }
    });
  };

  const handleAdditionalFilterDropdownChecked = (
    key: string,
    value: string
  ) => {
    setSelectAdditionalFilter((prev: any) => {
      const existing = prev.find((item: any) => item.key === key);
      if (existing) {
        const existsInValue = existing.value.includes(value);
        if (existsInValue) {
          const updatedValue = existing.value.filter((v: any) => v !== value);
          if (updatedValue.length === 0) {
            return prev.filter((item: any) => item.key !== key); // remove entire group
          } else {
            return prev.map((item: any) =>
              item.key === key ? { ...item, value: updatedValue } : item
            );
          }
        } else {
          return prev.map((item: any) =>
            item.key === key ? { ...item, value: [...item.value, value] } : item
          );
        }
      } else {
        return [...prev, { key, value: [value] }];
      }
    });
  };

  const handleAdditionalFilterRadioChecked = (key: string, value: string) => {
    setRadioAdditionalFilter((prev: any) => {
      const existing = prev.find((item: any) => item.key === key);
      if (existing) {
        const existsInValue = existing.value.includes(value);
        if (existsInValue) {
          const updatedValue = existing.value.filter((v: any) => v !== value);
          if (updatedValue.length === 0) {
            return prev.filter((item: any) => item.key !== key); // remove entire group
          } else {
            return prev.map((item: any) =>
              item.key === key ? { ...item, value: updatedValue } : item
            );
          }
        } else {
          return prev.map((item: any) =>
            item.key === key ? { ...item, value: [...item.value, value] } : item
          );
        }
      } else {
        return [...prev, { key, value: [value] }];
      }
    });
  };

  const clearAdditionalFilterChecked = (value: {
    key: string;
    value: string;
  }) => {
    setCheckedAdditionalFilter(
      (prev: any) =>
        prev
          .map((item: any) =>
            item.key === value.key
              ? {
                  ...item,
                  value: item.value.filter((v: any) => v !== value.value),
                }
              : item
          )
          .filter((item: any) => item.value.length > 0) // remove empty groups
    );
  };

  const clearSelectFilterChecked = (value: { key: string; value: string }) => {
    setSelectAdditionalFilter(
      (prev: any) =>
        prev
          .map((item: any) =>
            item.key === value.key
              ? {
                  ...item,
                  value: item.value.filter((v: any) => v !== value.value),
                }
              : item
          )
          .filter((item: any) => item.value.length > 0) // remove empty groups
    );
  };

  const clearRadioFilterChecked = (value: { key: string; value: string }) => {
    setRadioAdditionalFilter(
      (prev: any) =>
        prev
          .map((item: any) =>
            item.key === value.key
              ? {
                  ...item,
                  value: item.value.filter((v: any) => v !== value.value),
                }
              : item
          )
          .filter((item: any) => item.value.length > 0) // remove empty groups
    );
  };

  const handleAscending = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const branchParam = urlSearchParams.get("filteredBranches");
    const batchParam = urlSearchParams.get("filteredBatches");
    const courseParam = urlSearchParams.get("filteredCourses");
    const paymentTypeParam = urlSearchParams.get("filteredPaymentType");
    const paymentStatusParam = urlSearchParams.get("filteredPaymentStatus");
    const batchStatusParam = urlSearchParams.get("filteredBatchStatus");
    const tagsParam = urlSearchParams.get("filteredTags");

    const batchStatusInUrl = batchStatusParam
      ? batchStatusParam.split("|").map((item: string) => ({
          batchStatus: item,
        }))
      : [];
    const paymentTypeInUrl = paymentTypeParam
      ? paymentTypeParam.split("|").map((item: string) => ({
          paymentType: item,
        }))
      : [];
    const paymentStatusInUrl = paymentStatusParam
      ? paymentStatusParam.split("|").map((item: string) => ({
          paymentStatus: item,
        }))
      : [];
    const courseIdInUrl = courseParam
      ? courseParam.split("|").map((item: string) => ({
          id: item,
        }))
      : [];
    const branchIdInUrl = branchParam
      ? branchParam.split("|").map((item: string) => ({
          id: item,
        }))
      : [];
    const batchIdInUrl = batchParam
      ? batchParam.split("|").map((item: string) => ({ id: item }))
      : [];

    const tagStatusInUrl = tagsParam
      ? tagsParam.split("|").map((item: string) => ({
          value: item,
        }))
      : [];

    const dynamicChecked: any[] = [];
    const dynamicSelect: any[] = [];
    const dynamicRadio: any[] = [];

    urlSearchParams.forEach((value, key) => {
      const predefinedKeys = [
        "filteredBranches",
        "filteredBatches",
        "filteredCourses",
        "filteredPaymentType",
        "filteredPaymentStatus",
        "filteredBatchStatus",
        "filteredTags",
      ];

      if (!predefinedKeys.includes(key)) {
        const fieldMeta = customFieldsForFilter?.find(
          (f: any) => f.fieldName === key
        );

        if (fieldMeta) {
          const parsedValue = value.split(",");
          const entry = { key, value: parsedValue };

          if (fieldMeta.fieldType === "checkbox") {
            dynamicChecked.push(entry);
          } else if (fieldMeta.fieldType === "select") {
            dynamicSelect.push(entry);
          } else if (fieldMeta.fieldType === "radio") {
            dynamicRadio.push(entry);
          }
        }
      }
    });
    const queryParams = new URLSearchParams(window.location.search);

    queryParams.set("sortingOrder", "asc");
    const queryString = queryParams.toString();
    const newUrl = `${window.location.pathname}${
      queryString ? `?${queryString}` : ""
    }`;

    window.history.pushState({}, "", newUrl);
    studentListApiCall(
      batchStatusInUrl,
      paymentTypeInUrl,
      paymentStatusInUrl,
      courseIdInUrl,
      branchIdInUrl,
      batchIdInUrl,
      studentsStatus,
      tagStatusInUrl,
      dynamicChecked,
      dynamicSelect,
      dynamicRadio,
      value,
      "asc"
    );
    setSortingOrder("asc");
  };

  const handleDescending = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const branchParam = urlSearchParams.get("filteredBranches");
    const batchParam = urlSearchParams.get("filteredBatches");
    const courseParam = urlSearchParams.get("filteredCourses");
    const paymentTypeParam = urlSearchParams.get("filteredPaymentType");
    const paymentStatusParam = urlSearchParams.get("filteredPaymentStatus");
    const batchStatusParam = urlSearchParams.get("filteredBatchStatus");
    const tagsParam = urlSearchParams.get("filteredTags");

    const batchStatusInUrl = batchStatusParam
      ? batchStatusParam.split("|").map((item: string) => ({
          batchStatus: item,
        }))
      : [];
    const paymentTypeInUrl = paymentTypeParam
      ? paymentTypeParam.split("|").map((item: string) => ({
          paymentType: item,
        }))
      : [];
    const paymentStatusInUrl = paymentStatusParam
      ? paymentStatusParam.split("|").map((item: string) => ({
          paymentStatus: item,
        }))
      : [];
    const courseIdInUrl = courseParam
      ? courseParam.split("|").map((item: string) => ({
          id: item,
        }))
      : [];
    const branchIdInUrl = branchParam
      ? branchParam.split("|").map((item: string) => ({
          id: item,
        }))
      : [];
    const batchIdInUrl = batchParam
      ? batchParam.split("|").map((item: string) => ({ id: item }))
      : [];

    const tagStatusInUrl = tagsParam
      ? tagsParam.split("|").map((item: string) => ({
          value: item,
        }))
      : [];

    const dynamicChecked: any[] = [];
    const dynamicSelect: any[] = [];
    const dynamicRadio: any[] = [];

    urlSearchParams.forEach((value, key) => {
      const predefinedKeys = [
        "filteredBranches",
        "filteredBatches",
        "filteredCourses",
        "filteredPaymentType",
        "filteredPaymentStatus",
        "filteredBatchStatus",
        "filteredTags",
      ];

      if (!predefinedKeys.includes(key)) {
        const fieldMeta = customFieldsForFilter?.find(
          (f: any) => f.fieldName === key
        );

        if (fieldMeta) {
          const parsedValue = value.split(",");
          const entry = { key, value: parsedValue };

          if (fieldMeta.fieldType === "checkbox") {
            dynamicChecked.push(entry);
          } else if (fieldMeta.fieldType === "select") {
            dynamicSelect.push(entry);
          } else if (fieldMeta.fieldType === "radio") {
            dynamicRadio.push(entry);
          }
        }
      }
    });
    const queryParams = new URLSearchParams(window.location.search);

    queryParams.set("sortingOrder", "desc");
    const queryString = queryParams.toString();
    const newUrl = `${window.location.pathname}${
      queryString ? `?${queryString}` : ""
    }`;

    window.history.pushState({}, "", newUrl);
    studentListApiCall(
      batchStatusInUrl,
      paymentTypeInUrl,
      paymentStatusInUrl,
      courseIdInUrl,
      branchIdInUrl,
      batchIdInUrl,
      studentsStatus,
      tagStatusInUrl,
      dynamicChecked,
      dynamicSelect,
      dynamicRadio,
      value,
      "desc"
    );
    setSortingOrder("desc");
  };

  return (
    <div
      style={{
        padding: "14px 16px",
        overflowY: "hidden",
        minHeight: "calc(100vh - 64px)",
        maxHeight: "calc(100vh - 64px)",
        position: "relative",
        background: "rgb(245, 245, 245)",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "22px 30px 22px 30px",
          width: "100%",
          border: "1px solid #E9E9E9",
          borderRadius: "8px",
          overflowY: "auto",
          minHeight: "calc(100vh - 90px)",
          maxHeight: "calc(100vh - 90px)",
        }}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "space-between",
          }}
        >
          {studentDetails == null ? (
            <Skeleton
              animation="wave"
              variant="rectangular"
              width="150px"
              height={38}
              style={{
                borderRadius: "2px",
                marginBottom: "16px",
                marginTop: "16px",
              }}
            />
          ) : (
            <>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    margin: "0px",
                    color: "#142C44",
                    fontSize: "18px",
                    fontFamily: "Poppins",
                    fontWeight: "500",
                  }}
                >
                  Students
                </p>
              </Box>
            </>
          )}

          <Box sx={{ display: "flex", alignItems: "center" }}>
            {studentDetails == null || studentListLoading ? (
              <Skeleton
                animation="wave"
                variant="rectangular"
                width="250px"
                height={38}
                style={{
                  borderRadius: "2px",
                  marginRight: "10px",
                  marginBottom: "16px",
                  marginTop: "16px",
                }}
              />
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    marginBottom: "5px",
                    gap: "10px",
                  }}
                >
                  <OpenSearch
                    fromNurture={false}
                    selectedStudent={selectedStudent}
                    placeholder="Search Students"
                  />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "4PX",
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      height: "38px",
                      overflow: "hidden",
                    }}
                  >
                    <Tooltip title="Active Students" arrow>
                      <span>
                        <button
                          style={{
                            cursor: onStudentsLoading ? "auto" : "pointer",
                            border: "none",
                            background: studentsStatusCheck
                              ? "#fff"
                              : "rgba(17, 200, 155, 0.10)",
                            height: "37px",
                            width: "37px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                          disabled={onStudentsLoading}
                          onClick={() => {
                            handleStudentStatusChange(
                              false,
                              selectedStudent?.studentId
                            );
                            dispatch(
                              setIsActiveLostTrigger(!isActiveLostTriggered)
                            );
                          }}
                        >
                          <img
                            src={
                              !studentsStatusCheck
                                ? leadActiveIcon
                                : leadActiveDefault
                            }
                            alt="leadActiveIcon"
                          />
                        </button>
                      </span>
                    </Tooltip>

                    <div
                      style={{
                        background: "#D0D5DD",
                        width: "1px",
                        height: "100%",
                      }}
                    ></div>
                    <Tooltip title="Lost Students" arrow>
                      <span>
                        <button
                          style={{
                            cursor: onStudentsLoading ? "auto" : "pointer",
                            border: "none",
                            background: studentsStatusCheck
                              ? "rgba(236, 57, 57, 0.12)"
                              : "#fff",
                            height: "37px",
                            width: "37px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                          disabled={onStudentsLoading}
                          onClick={() => {
                            handleStudentStatusChange(
                              true,
                              selectedStudent?.studentId
                            );
                            dispatch(
                              setIsActiveLostTrigger(!isActiveLostTriggered)
                            );
                          }}
                        >
                          <img
                            src={
                              !studentsStatusCheck
                                ? leadLostDefault
                                : leadLostIcon
                            }
                            alt="leadLostIcon"
                          />
                        </button>
                      </span>
                    </Tooltip>
                  </div>
                </div>
              </>
            )}

            {studentDetails == null || studentListLoading ? (
              <Skeleton
                animation="wave"
                variant="rectangular"
                width="50px"
                height={38}
                style={{
                  borderRadius: "2px",
                  marginBottom: "16px",
                  marginTop: "16px",
                }}
              />
            ) : (
              <>
                <Box sx={{ width: "fit-content" }}>
                  <button
                    style={{
                      padding: "8px 12px",
                      backgroundColor: anchorEl ? "#ECF7F4" : "transparent",
                      border: anchorEl
                        ? "1px solid #68DBBF"
                        : "1px solid #D0D5DD",
                      borderRadius: "4px",
                      margin: "0px 14px",
                      cursor: "pointer",
                      marginBottom: "8px",
                    }}
                    id={id}
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CiViewColumn
                        size={22}
                        color={anchorEl ? "#11C89B" : "#667085"}
                      />
                    </div>
                  </button>
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    sx={{ display: "flex", boxShadow: "none" }}
                    PaperProps={{
                      sx: {
                        boxShadow:
                          "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
                        border: "1px solid #F2F4F7",
                        borderRadius: "8px",
                        minWidth: "200px",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        padding: "10px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {columns
                        .slice(2, columns.length)
                        .filter((item: any) => item.label !== "Student Name")
                        .map((ele) => (
                          <FormControlLabel
                            key={ele?.id}
                            onChange={toggleColumn}
                            value={ele.show}
                            control={
                              <Checkbox
                                checked={ele.show}
                                sx={{
                                  strokeWidth: 1,
                                  color: "#D0D5DD",
                                  "&:hover": {
                                    backgroundColor: "transparent",
                                  },
                                  "&:focus": {
                                    backgroundColor: "transparent",
                                  },
                                }}
                              />
                            }
                            label={ele.label}
                            name={ele.label}
                            disabled={ele.label === "Student Name"}
                            sx={{
                              fontSize: "13px",
                              color: "#667085",
                            }}
                          />
                        ))}
                    </Box>
                  </Popover>
                </Box>

                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    marginBottom: "10px",
                    gap: "10px",
                  }}
                >
                  <FilterDrawer
                    handleFilterApply={handleFilterApply}
                    handleResetClick={handleResetClick}
                    activeFilter={filterApplied}
                    cancelClick={cancelClick}
                    closeSetFilter={handleFilterClose}
                  >
                    <div
                      style={{
                        padding: "22px 32px",
                        overflowY: "auto",
                        maxHeight: "calc(100% - 110px)",
                      }}
                    >
                      <FilterChipsWrap>
                        {checkedBatchStatus?.length > 0 &&
                          checkedBatchStatus?.map((item) => (
                            <FilterChips
                              key={item?.batchStatus}
                              keyVal={item?.batchStatus}
                              chipName={item?.batchStatus?.toLowerCase()}
                              clearValue={item?.batchStatus}
                              closeFunction={clearCheckedBatchStatus}
                            />
                          ))}
                        {checkedPaymentStatus.length > 0 &&
                          checkedPaymentStatus.map((item) => (
                            <FilterChips
                              key={item.paymentStatus}
                              keyVal={item.paymentStatus}
                              chipName={item.paymentStatus}
                              clearValue={item.paymentStatus}
                              closeFunction={clearCheckedPaymentStatus}
                            />
                          ))}

                        {checkedPaymentType.length > 0 &&
                          checkedPaymentType.map((item) => (
                            <FilterChips
                              key={item.paymentType}
                              keyVal={item.paymentType}
                              chipName={item.paymentType}
                              clearValue={item.paymentType}
                              closeFunction={clearCheckedPaymentType}
                            />
                          ))}

                        {checkedBranches.length > 0 &&
                          checkedBranches.map((item) => (
                            <FilterChips
                              key={item.id}
                              keyVal={item.id}
                              chipName={item.branchName}
                              clearValue={item.id}
                              closeFunction={clearCheckedBranch}
                            />
                          ))}

                        {checkedCourses.length > 0 &&
                          checkedCourses.map((item) => (
                            <FilterChips
                              key={item.id}
                              keyVal={item.id}
                              chipName={item.courseName}
                              clearValue={item.id}
                              closeFunction={clearCheckedCourse}
                            />
                          ))}
                        {checkedBatches.length > 0 &&
                          checkedBatches.map((item) => (
                            <FilterChips
                              key={item.id}
                              keyVal={item.id}
                              chipName={item.batchName}
                              clearValue={item.id}
                              closeFunction={clearCheckedBatch}
                            />
                          ))}
                        {checkedTags.length > 0 &&
                          checkedTags.map((item: any) => (
                            <FilterChips
                              key={item.value}
                              keyVal={item.value}
                              chipName={item.value.toLowerCase()}
                              clearValue={item.value}
                              closeFunction={clearCheckedTag}
                            />
                          ))}

                        {checkedAdditionalFilter.length > 0 &&
                          checkedAdditionalFilter.flatMap((item: any) =>
                            item.value.map((val: string) => (
                              <FilterChips
                                key={`${item.key}-${val}`}
                                keyVal={`${item.key}-${val}`}
                                chipName={`${item.key}: ${val}`.toLowerCase()}
                                clearValue={{ key: item.key, value: val }} // structured data
                                closeFunction={clearAdditionalFilterChecked}
                              />
                            ))
                          )}
                        {selectAdditionalFilter.length > 0 &&
                          selectAdditionalFilter.flatMap((item: any) =>
                            item.value.map((val: string) => (
                              <FilterChips
                                key={`${item.key}-${val}`}
                                keyVal={`${item.key}-${val}`}
                                chipName={`${item.key}: ${val}`.toLowerCase()}
                                clearValue={{ key: item.key, value: val }}
                                closeFunction={clearSelectFilterChecked}
                              />
                            ))
                          )}
                        {radioAdditionalFilter.length > 0 &&
                          radioAdditionalFilter.flatMap((item: any) =>
                            item.value.map((val: string) => (
                              <FilterChips
                                key={`${item.key}-${val}`}
                                keyVal={`${item.key}-${val}`}
                                chipName={`${item.key}: ${val}`.toLowerCase()}
                                clearValue={{ key: item.key, value: val }}
                                closeFunction={clearRadioFilterChecked}
                              />
                            ))
                          )}
                      </FilterChipsWrap>

                      <div style={{ margin: "15px 0px" }}>
                        <FilterLabel labelValue="Default Parameters" />
                      </div>
                      <FilterTypeWrap>
                        <FilterLabel labelValue="Batch Status" />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {[
                              { batchStatus: "ONGOING" },
                              { batchStatus: "UPCOMING" },
                              { batchStatus: "CANCELLED" },
                              { batchStatus: "COMPLETED" },
                            ].map((item: any) => (
                              <FilterCheckbox
                                key={item?.batchStatus}
                                keyVal={item?.batchStatus}
                                checked={checkedBatchStatus?.some(
                                  (data) =>
                                    data?.batchStatus?.toLowerCase() ===
                                    item?.batchStatus?.toLowerCase()
                                )}
                                checkboxFunction={() =>
                                  handleFilterBatchStatusChecked(
                                    item?.batchStatus
                                  )
                                }
                                label={item?.batchStatus?.toLowerCase()}
                              />
                            ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                      </FilterTypeWrap>

                      <FilterTypeWrap>
                        <FilterLabel labelValue="Payment Type" />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {[
                              { paymentType: "Regular" },
                              { paymentType: "Membership" },
                              { paymentType: "Session" },
                            ].map((item: any) => (
                              <FilterCheckbox
                                key={item.paymentType}
                                keyVal={item.paymentType}
                                checked={checkedPaymentType.some(
                                  (data) =>
                                    data.paymentType
                                      .toLowerCase()
                                      .replace(/_/g, " ") ===
                                    item.paymentType
                                      .toLowerCase()
                                      .replace(/_/g, " ")
                                )}
                                checkboxFunction={() =>
                                  handleFilterPaymentTypeChecked(
                                    item.paymentType
                                  )
                                }
                                label={item.paymentType
                                  .toLowerCase()
                                  .replace(/_/g, " ")}
                              />
                            ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                      </FilterTypeWrap>

                      <FilterTypeWrap>
                        <FilterLabel labelValue="Payment Status" />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {displayedPaymentStatuses?.map((item: any) => (
                              <FilterCheckbox
                                key={item?.paymentStatus}
                                keyVal={item?.paymentStatus}
                                checked={checkedPaymentStatus.some(
                                  (data) =>
                                    data?.paymentStatus?.toLowerCase() ===
                                    item?.paymentStatus?.toLowerCase()
                                )}
                                checkboxFunction={() =>
                                  handleFilterPaymentStatusChecked(
                                    item?.paymentStatus
                                  )
                                }
                                label={item?.paymentStatus?.toLowerCase()}
                              />
                            ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                        <ShowAllBtn
                          clickFunction={handleShowMorePaymentStatuses}
                          showAll={showAllPaymentStatuses}
                          filteredState={paymentStatusArray}
                        />
                      </FilterTypeWrap>

                      <FilterTypeWrap>
                        <FilterLabel labelValue="Course" />
                        <FilterSearchField
                          value={searchCourse}
                          onChange={handleCourseSearch}
                          placeholder="Search Course"
                        />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {courses &&
                              displayedCourses?.map((item: any) => (
                                <FilterCheckbox
                                  key={item.id}
                                  keyVal={item.id}
                                  checked={checkedCourses.some(
                                    (data) => data.id === item.id
                                  )}
                                  checkboxFunction={() =>
                                    handleFilterCourseChecked(
                                      item.id,
                                      item.courseName
                                    )
                                  }
                                  label={item.courseName.toLowerCase()}
                                />
                              ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                        <ShowAllBtn
                          clickFunction={handleShowMoreCourses}
                          showAll={showAllCourses}
                          filteredState={courses}
                        />
                      </FilterTypeWrap>

                      <FilterTypeWrap>
                        <FilterLabel labelValue="Batch" />
                        <FilterSearchField
                          value={searchBatch}
                          onChange={handleBatchSearch}
                          placeholder="Search Batch"
                        />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {batchList &&
                              displayedBatches?.map((item: any) => {
                                return (
                                  <FilterCheckbox
                                    key={item.id}
                                    keyVal={item.id}
                                    checked={checkedBatches.some(
                                      (data) => data.id === item.id
                                    )}
                                    checkboxFunction={() =>
                                      handleFilterBatchChecked(
                                        item.id,
                                        item.batchName
                                      )
                                    }
                                    label={item.batchName.toLowerCase()}
                                    isBatchCompleted={
                                      item?.batchStatus === "COMPLETED"
                                        ? true
                                        : false
                                    }
                                  />
                                );
                              })}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                        <ShowAllBtn
                          clickFunction={handleShowMoreBatches}
                          showAll={showAllBatch}
                          filteredState={filteredBatches}
                        />
                      </FilterTypeWrap>

                      {hasAllBranchAccess && (
                        <FilterTypeWrap>
                          <FilterLabel labelValue="Branch" />

                          <FilterSearchField
                            value={searchBranch}
                            onChange={handleBranchSearch}
                            placeholder="Search Branch"
                          />
                          <FilterCheckBoxWrap>
                            <FormGroup>
                              {branches &&
                                displayedBranch?.map((item: any) => (
                                  <FilterCheckbox
                                    key={item.id}
                                    keyVal={item.id}
                                    checked={checkedBranches.some(
                                      (data) => data.id === item.id
                                    )}
                                    checkboxFunction={() =>
                                      handleFilterBranchChecked(
                                        item.id,
                                        item.branchName
                                      )
                                    }
                                    label={item.branchName.toLowerCase()}
                                  />
                                ))}
                            </FormGroup>
                          </FilterCheckBoxWrap>
                          <ShowAllBtn
                            clickFunction={handleShowMoreBranches}
                            showAll={showAllBranches}
                            filteredState={filteredBranches}
                          />
                        </FilterTypeWrap>
                      )}
                      <FilterTypeWrap>
                        <FilterLabel labelValue="Tag" />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {[
                              { id: 0, value: "Select" },
                              { id: 1, value: "Cold" },
                              { id: 2, value: "Warm" },
                              { id: 3, value: "Hot" },
                              { id: 4, value: "Interested" },
                              { id: 5, value: "Followup" },
                              { id: 6, value: "Invalid" },
                              { id: 7, value: "Disqualified" },
                              { id: 8, value: "Not Answering" },
                              { id: 9, value: "Not Interested" },
                              { id: 10, value: "Future Prospect" },
                              { id: 11, value: "Budget Constraint" },
                              { id: 12, value: "Not Reachable" },
                              { id: 13, value: "Lost" },
                              { id: 14, value: "Shortlisted" },
                              { id: 15, value: "Admission" },
                              { id: 16, value: "Exam Schedule" },
                              { id: 17, value: "Qualified" },
                              { id: 18, value: "Placement Done" },
                              { id: 19, value: "Flexi Payment Plan" },
                              { id: 20, value: "Call Back" },
                              { id: 21, value: "Discontinued" },
                              { id: 22, value: "Discontinued and Refunded" },
                            ].map((item: any) => (
                              <FilterCheckbox
                                key={item.id}
                                keyVal={item.id}
                                checked={checkedTags.some(
                                  (data: any) =>
                                    data.value.toLowerCase() ===
                                    item.value.toLowerCase()
                                )}
                                checkboxFunction={() =>
                                  handleFilterTagsChecked(item.value)
                                }
                                label={item.value.toLowerCase()}
                              />
                            ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                      </FilterTypeWrap>
                      <div style={{ margin: "15px 0px" }}>
                        <FilterLabel labelValue="Additional Details" />
                      </div>
                      {customFieldsForFilter
                        ?.filter((d: any) => d?.fieldType === "select")
                        ?.map((selectField: any) => (
                          <FilterTypeWrap key={selectField.fieldName}>
                            <FilterLabel labelValue={selectField.fieldName} />
                            <FilterCheckBoxWrap>
                              <FormGroup>
                                {selectField?.options?.map((item: any) => (
                                  <FilterCheckbox
                                    key={item.id}
                                    keyVal={item.id}
                                    checked={selectAdditionalFilter
                                      ?.find(
                                        (f: any) =>
                                          f.key === selectField.fieldName
                                      )
                                      ?.value.includes(item.id)}
                                    checkboxFunction={() =>
                                      handleAdditionalFilterDropdownChecked(
                                        selectField.fieldName,
                                        item.id
                                      )
                                    }
                                    label={item.name?.toLowerCase()}
                                  />
                                ))}
                              </FormGroup>
                            </FilterCheckBoxWrap>
                          </FilterTypeWrap>
                        ))}
                      {customFieldsForFilter
                        ?.filter((d: any) => d?.fieldType === "checkbox")
                        ?.map((selectField: any) => (
                          <FilterTypeWrap key={selectField.fieldName}>
                            <FilterLabel labelValue={selectField.fieldName} />
                            <FilterCheckBoxWrap>
                              <FormGroup>
                                {selectField?.options?.map((item: any) => (
                                  <FilterCheckbox
                                    key={item.id}
                                    keyVal={item.id}
                                    checked={checkedAdditionalFilter
                                      ?.find(
                                        (f: any) =>
                                          f.key === selectField.fieldName
                                      )
                                      ?.value.includes(item.id)}
                                    checkboxFunction={() =>
                                      handleAdditionalFilterChecked(
                                        selectField.fieldName,
                                        item.id
                                      )
                                    }
                                    label={item.name?.toLowerCase()}
                                  />
                                ))}
                              </FormGroup>
                            </FilterCheckBoxWrap>
                          </FilterTypeWrap>
                        ))}
                      {customFieldsForFilter
                        ?.filter((d: any) => d?.fieldType === "radio")
                        ?.map((selectField: any) => (
                          <FilterTypeWrap key={selectField.fieldName}>
                            <FilterLabel labelValue={selectField.fieldName} />
                            <FilterCheckBoxWrap>
                              <FormGroup>
                                {selectField?.options?.map((item: any) => (
                                  <FilterCheckbox
                                    key={item.id}
                                    keyVal={item.id}
                                    checked={radioAdditionalFilter
                                      ?.find(
                                        (f: any) =>
                                          f.key === selectField.fieldName
                                      )
                                      ?.value.includes(item.id)}
                                    checkboxFunction={() =>
                                      handleAdditionalFilterRadioChecked(
                                        selectField.fieldName,
                                        item.id
                                      )
                                    }
                                    label={item.name?.toLowerCase()}
                                  />
                                ))}
                              </FormGroup>
                            </FilterCheckBoxWrap>
                          </FilterTypeWrap>
                        ))}
                    </div>
                  </FilterDrawer>
                </div>
              </>
            )}
          </Box>
        </Box>

        <div
          style={{
            minHeight: "calc(100vh - 210px)",
            overflowY: "hidden",
          }}
        >
          {studentListLoading ? (
            <TableSkeleton />
          ) : (
            <>
              <div
                style={{
                  border: "1px solid #EAECF0",
                  borderRadius: "8px",
                  minHeight: "calc(100vh - 210px)",
                  position: "relative",
                  overflowY: "hidden",
                  marginTop: "5px",
                }}
              >
                {studentItems?.length > 0 ? (
                  <TableContainer
                    sx={{
                      maxHeight: "calc(100vh - 215px)",
                      minHeight: "calc(100vh - 215px)",
                      overflowY: "auto",
                    }}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow sx={{ height: "49px" }}>
                          {columns.map((column: any) => {
                            return (
                              <>
                                {column.show && (
                                  <CustomTableHeaderCell
                                    key={column.id}
                                    align={column?.align}
                                    style={{ minWidth: column.minWidth }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px",
                                      }}
                                    >
                                      {column.label}
                                      {column.label === "Student ID" && (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "-10",
                                          }}
                                        >
                                          {sortingOrder === "desc" ? (
                                            <ArrowDropDownIcon
                                              onClick={() =>
                                                handleAscending("studentId")
                                              }
                                              sx={{
                                                fontSize: "20px",
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <ArrowDropUpIcon
                                              onClick={() =>
                                                handleDescending("studentId")
                                              }
                                              sx={{
                                                fontSize: "20px",
                                                cursor: "pointer",
                                              }}
                                            />
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </CustomTableHeaderCell>
                                )}
                              </>
                            );
                          })}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {studentDetails?.length > 0 &&
                          studentItems?.map((student: any, index: any) => {
                            return (
                              <TableRow
                                role="checkbox"
                                tabIndex={-1}
                                key={index}
                                sx={{
                                  padding: "0px",
                                  height: "72px",
                                  cursor: "pointer",
                                }}
                                className="student_table_body"
                                onClick={() =>
                                  hasLeadCardPermission
                                    ? openLeadExpandModal(
                                        student?._source?.instituteId,
                                        student?._source?.contactNumber,
                                        student?._source?.email,
                                        student?.inner_hits?.batchstudentmapping
                                          ?.hits?.hits?.[0]?._source?.enquiryId,
                                        dispatch,
                                        ""
                                      )
                                    : dispatch(
                                        setToastNotification({
                                          message: String(
                                            "You do not have permission to access the lead card"
                                          ),
                                          type: "error",
                                          snackOpen: true,
                                        })
                                      )
                                }
                              >
                                <CustomTableCell>{index + 1}</CustomTableCell>
                                <CustomTableCell
                                  style={{
                                    color: "#667085",
                                    margin: "0px",
                                    fontSize: "13px",
                                  }}
                                >
                                  {student?._source?.studentId}
                                </CustomTableCell>
                                {columns[2].show && (
                                  <CustomTableCell sx={{}}>
                                    <div>
                                      <p
                                        style={{
                                          color: "#101828",
                                          margin: "0px",
                                          fontSize: "12px",
                                          fontWeight: "400",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {student?._source?.firstName}{" "}
                                        {student?._source?.lastName}
                                      </p>
                                      <p
                                        style={{
                                          color: "#667085",
                                          margin: "0px",
                                          fontSize: "13px",
                                          fontWeight: "400",
                                        }}
                                      >
                                        {`${student?._source?.email}`}
                                      </p>
                                      <p
                                        style={{
                                          color: "#667085",
                                          margin: "0px",
                                          fontSize: "13px",
                                          fontWeight: "400",
                                        }}
                                      >
                                        {student?._source?.contactNumber &&
                                        typeof student?._source
                                          ?.contactNumber === "string"
                                          ? ` +${
                                              student?._source
                                                ?.contactCountryCode || "91"
                                            } ${
                                              student?._source?.contactNumber?.startsWith(
                                                student?.contactCountryCode ||
                                                  "91"
                                              )
                                                ? student?._source?.contactNumber?.replace(
                                                    student?.contactCountryCode ||
                                                      "91",
                                                    ""
                                                  )
                                                : student?._source
                                                    ?.contactNumber
                                            }`
                                          : ""}
                                        {/* {student?._source?.contactNumber
                                          ? student?._source?.contactNumber?.startsWith(
                                              "971"
                                            )
                                            ? `+971 ${student?._source?.contactNumber.slice(
                                                3
                                              )}`
                                            : student?._source?.contactNumber?.startsWith(
                                                "91"
                                              )
                                            ? `+91 ${student?._source?.contactNumber.slice(
                                                2
                                              )}`
                                            : ""
                                          : ""} */}
                                      </p>
                                    </div>
                                  </CustomTableCell>
                                )}

                                {columns[3].show && (
                                  <CustomTableCell sx={{}}>
                                    <Box>
                                      <>
                                        {student?.inner_hits
                                          ?.batchstudentmapping?.hits?.hits?.[0]
                                          ?._source?.batchStatus && (
                                          <p
                                            style={{
                                              color:
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source
                                                  ?.batchStatus === "ONGOING"
                                                  ? "#3DB985"
                                                  : student?.inner_hits
                                                      ?.batchstudentmapping
                                                      ?.hits?.hits?.[0]?._source
                                                      ?.batchStatus ===
                                                    "UPCOMING"
                                                  ? "#EBA418"
                                                  : student?.inner_hits
                                                      ?.batchstudentmapping
                                                      ?.hits?.hits?.[0]?._source
                                                      ?.batchStatus ===
                                                    "COMPLETED"
                                                  ? "#027A48"
                                                  : "#3DB985",
                                              backgroundColor:
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source
                                                  ?.batchStatus === "ONGOING"
                                                  ? "#ECFDF3"
                                                  : student?.inner_hits
                                                      ?.batchstudentmapping
                                                      ?.hits?.hits?.[0]?._source
                                                      ?.batchStatus ===
                                                    "UPCOMING"
                                                  ? "#FFFAEB"
                                                  : student?.inner_hits
                                                      ?.batchstudentmapping
                                                      ?.hits?.hits?.[0]?._source
                                                      ?.batchStatus ===
                                                    "COMPLETED"
                                                  ? "#ECFDF3"
                                                  : "#ECFDF3",
                                              textAlign: "center",
                                              borderRadius: "16px",
                                              padding: "2px 5px",
                                              fontSize: "12px",
                                              lineHeight: "18px",
                                              fontWeight: "500",
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {student?.inner_hits?.batchstudentmapping?.hits?.hits?.[0]?._source?.batchStatus?.toLowerCase()}
                                          </p>
                                        )}
                                      </>
                                    </Box>
                                  </CustomTableCell>
                                )}

                                {columns[4].show && (
                                  <CustomTableCell sx={{}}>
                                    <>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <p
                                          style={{
                                            color: "#667085",
                                            margin: "0px",
                                            textTransform: "capitalize",
                                            fontSize: "13px",
                                            fontWeight: "400",
                                          }}
                                        >
                                          {
                                            student?.inner_hits
                                              ?.batchstudentmapping?.hits
                                              ?.hits?.[0]?._source?.courseName
                                          }
                                        </p>
                                        {student?.inner_hits
                                          ?.batchstudentmapping?.hits?.hits
                                          ?.length > 1 && (
                                          <p
                                            style={{
                                              padding: "4px",
                                              borderRadius: "100%",
                                              backgroundColor:
                                                "rgba(17, 200, 155, 0.06)",
                                              width: "24px",
                                              height: "24px",
                                              margin: "0px 4px",
                                              fontSize: "12px",
                                              textAlign: "center",
                                              color: "#11C89B",
                                            }}
                                          >
                                            +
                                            {student?.inner_hits
                                              ?.batchstudentmapping?.hits?.hits
                                              ?.length - 1}
                                          </p>
                                        )}
                                      </Box>
                                    </>
                                  </CustomTableCell>
                                )}

                                {columns[5].show && (
                                  <CustomTableCell sx={{}}>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <p
                                        style={{
                                          color: "#667085",
                                          margin: "0px",
                                          textTransform: "capitalize",
                                          fontSize: "13px",
                                          fontWeight: "400",
                                        }}
                                      >
                                        {
                                          student?.inner_hits
                                            ?.batchstudentmapping?.hits
                                            ?.hits?.[0]?._source?.batchName
                                        }
                                      </p>
                                    </Box>
                                  </CustomTableCell>
                                )}

                                {columns[6].show && (
                                  <CustomTableCell sx={{}}>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <p
                                        style={{
                                          color: "#667085",
                                          margin: "0px",
                                          textTransform: "capitalize",
                                          fontSize: "13px",
                                          fontWeight: "400",
                                        }}
                                      >
                                        {
                                          student?.inner_hits
                                            ?.batchstudentmapping?.hits
                                            ?.hits?.[0]?._source?.branchName
                                        }
                                      </p>
                                    </Box>
                                  </CustomTableCell>
                                )}

                                {columns[7].show && (
                                  <CustomTableCell
                                    align="left"
                                    sx={{ alignItems: "center" }}
                                  >
                                    <p
                                      style={{
                                        margin: "0px",
                                        color: "#667085",
                                        textAlign: "center",
                                        fontFamily: "Poppins",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        lineHeight: "18px",
                                        borderRadius: "4px",
                                        background: "#F3F3F3",
                                        padding: "3px 8px",
                                        display: "inline-flex",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {student?.inner_hits?.batchstudentmapping?.hits?.hits?.[0]?._source?.paymentType
                                        ?.toLowerCase()
                                        .replace(/_/g, " ")}
                                    </p>
                                  </CustomTableCell>
                                )}

                                {columns[8].show && (
                                  <CustomTableCell
                                    align="left"
                                    sx={{ alignItems: "center" }}
                                  >
                                    <p
                                      style={{
                                        color:
                                          student?.inner_hits
                                            ?.batchstudentmapping?.hits
                                            ?.hits?.[0]?._source
                                            ?.paymentStatus === "Partly Paid" ||
                                          student?.inner_hits
                                            ?.batchstudentmapping?.hits
                                            ?.hits?.[0]?._source
                                            ?.paymentStatus === "EMI Paid" ||
                                          student?.inner_hits
                                            ?.batchstudentmapping?.hits
                                            ?.hits?.[0]?._source
                                            ?.paymentStatus ===
                                            "Membership Fees Paid"
                                            ? "#EBA418"
                                            : student?.inner_hits
                                                ?.batchstudentmapping?.hits
                                                ?.hits?.[0]?._source
                                                ?.paymentStatus ===
                                                "Fully Paid" ||
                                              student?.inner_hits
                                                ?.batchstudentmapping?.hits
                                                ?.hits?.[0]?._source
                                                ?.paymentStatus ===
                                                "Emi Fully Paid" ||
                                              student?.inner_hits
                                                ?.batchstudentmapping?.hits
                                                ?.hits?.[0]?._source
                                                ?.paymentStatus ===
                                                "Membership Fully Paid"
                                            ? "#27AF77"
                                            : student?.inner_hits
                                                ?.batchstudentmapping?.hits
                                                ?.hits?.[0]?._source
                                                ?.paymentStatus ===
                                                "Membership Fees Due" ||
                                              student?.inner_hits
                                                ?.batchstudentmapping?.hits
                                                ?.hits?.[0]?._source
                                                ?.paymentStatus === "EMI Due" ||
                                              student?.inner_hits
                                                ?.batchstudentmapping?.hits
                                                ?.hits?.[0]?._source
                                                ?.paymentStatus === "Not Paid"
                                            ? "#EC3939"
                                            : "#EBA418",
                                        margin: "0px",
                                        fontSize: "143x",
                                        fontWeight: "500",
                                        alignItems: "center",
                                        gap: "2px",
                                        display: "list-item",
                                      }}
                                    >
                                      {
                                        student?.inner_hits?.batchstudentmapping
                                          ?.hits?.hits?.[0]?._source
                                          ?.paymentStatus
                                      }
                                    </p>
                                  </CustomTableCell>
                                )}

                                {columns[9].show && (
                                  <CustomTableCell
                                    align="left"
                                    sx={{ alignItems: "center" }}
                                  >
                                    <div
                                      style={{
                                        margin: "0px",
                                        color: "#667085",
                                        fontFamily: "Poppins",
                                        fontSize: "11px",
                                        fontWeight: "400",
                                        lineHeight: "20px",
                                      }}
                                    >
                                      {student?.inner_hits?.batchstudentmapping
                                        ?.hits?.hits?.[0]?._source
                                        ?.paymentType === "REGULAR" ? (
                                        <div>
                                          {student?.inner_hits
                                            ?.batchstudentmapping?.hits
                                            ?.hits?.[0]?._source?.emiExist ? (
                                            <>
                                              {student?.inner_hits
                                                ?.batchstudentmapping?.hits
                                                ?.hits?.[0]?._source
                                                ?.paymentStatus !==
                                                "Emi Fully Paid" && (
                                                <>
                                                  {student?.inner_hits
                                                    ?.batchstudentmapping?.hits
                                                    ?.hits?.[0]?._source
                                                    ?.paymentStatus ===
                                                  "EMI Due" ? (
                                                    <>
                                                      Due On:{" "}
                                                      {student?.inner_hits
                                                        ?.batchstudentmapping
                                                        ?.hits?.hits?.[0]
                                                        ?._source
                                                        ?.paymentDetails?.dueOn
                                                        ? moment
                                                            .unix(
                                                              student
                                                                ?.inner_hits
                                                                ?.batchstudentmapping
                                                                ?.hits
                                                                ?.hits?.[0]
                                                                ?._source
                                                                ?.paymentDetails
                                                                ?.dueOn / 1000
                                                            )
                                                            .format(
                                                              "DD/MM/YYYY"
                                                            )
                                                        : "N/A"}
                                                    </>
                                                  ) : (
                                                    <>
                                                      Next Due On:{" "}
                                                      {student?.inner_hits
                                                        ?.batchstudentmapping
                                                        ?.hits?.hits?.[0]
                                                        ?._source
                                                        ?.paymentDetails
                                                        ?.nextDueOn
                                                        ? moment
                                                            .unix(
                                                              student
                                                                ?.inner_hits
                                                                ?.batchstudentmapping
                                                                ?.hits
                                                                ?.hits?.[0]
                                                                ?._source
                                                                ?.paymentDetails
                                                                ?.nextDueOn /
                                                                1000
                                                            )
                                                            .format(
                                                              "DD/MM/YYYY"
                                                            )
                                                        : "N/A"}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                              <br />
                                              Paid EMIs:{" "}
                                              {/* {`${
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source
                                                  ?.paymentDetails?.paidEmi
                                              } |  ${handleSelectCurrency(
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source?.branchId
                                              )}${
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source
                                                  ?.paymentDetails?.amountPaid
                                                  ? student?.inner_hits
                                                      ?.batchstudentmapping
                                                      ?.hits?.hits?.[0]?._source
                                                      ?.paymentDetails
                                                      ?.amountPaid
                                                  : ""
                                              }
                                              
                                              `} */}
                                              {`${
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source
                                                  ?.paymentDetails?.paidEmi ||
                                                ""
                                              }${
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source
                                                  ?.paymentDetails?.amountPaid
                                                  ? ` | ${handleSelectCurrency(
                                                      student?.inner_hits
                                                        ?.batchstudentmapping
                                                        ?.hits?.hits?.[0]
                                                        ?._source?.branchId
                                                    )}${
                                                      student?.inner_hits
                                                        ?.batchstudentmapping
                                                        ?.hits?.hits?.[0]
                                                        ?._source
                                                        ?.paymentDetails
                                                        ?.amountPaid
                                                    }`
                                                  : ""
                                              }`}
                                              <br />
                                              Remaining EMIs:{" "}
                                              {/* {`${
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source
                                                  ?.paymentDetails?.remainingEmi
                                              } | ${handleSelectCurrency(
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source?.branchId
                                              )}${
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source
                                                  ?.paymentDetails
                                                  ?.remainingAmount
                                                  ? student?.inner_hits
                                                      ?.batchstudentmapping
                                                      ?.hits?.hits?.[0]?._source
                                                      ?.paymentDetails
                                                      ?.remainingAmount
                                                  : ""
                                              }`} */}
                                              {`${
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source
                                                  ?.paymentDetails
                                                  ?.remainingEmi || ""
                                              }${
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source
                                                  ?.paymentDetails
                                                  ?.remainingAmount
                                                  ? ` | ${handleSelectCurrency(
                                                      student?.inner_hits
                                                        ?.batchstudentmapping
                                                        ?.hits?.hits?.[0]
                                                        ?._source?.branchId
                                                    )}${
                                                      student?.inner_hits
                                                        ?.batchstudentmapping
                                                        ?.hits?.hits?.[0]
                                                        ?._source
                                                        ?.paymentDetails
                                                        ?.remainingAmount
                                                    }`
                                                  : ""
                                              }`}
                                            </>
                                          ) : (
                                            <>
                                              Total:{" "}
                                              <span
                                                style={{
                                                  fontFamily: "Roboto",
                                                }}
                                              >
                                                {handleSelectCurrency(
                                                  student?.inner_hits
                                                    ?.batchstudentmapping?.hits
                                                    ?.hits?.[0]?._source
                                                    ?.branchId
                                                )}
                                              </span>
                                              {
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source
                                                  ?.paymentDetails?.totalAmount
                                              }
                                              <br />
                                              Remaining:{" "}
                                              <span
                                                style={{
                                                  fontFamily: "Roboto",
                                                }}
                                              >
                                                {handleSelectCurrency(
                                                  student?.inner_hits
                                                    ?.batchstudentmapping?.hits
                                                    ?.hits?.[0]?._source
                                                    ?.branchId
                                                )}
                                              </span>
                                              {
                                                student?.inner_hits
                                                  ?.batchstudentmapping?.hits
                                                  ?.hits?.[0]?._source
                                                  ?.paymentDetails
                                                  ?.remainingAmount
                                              }
                                            </>
                                          )}
                                        </div>
                                      ) : student?.inner_hits
                                          ?.batchstudentmapping?.hits?.hits?.[0]
                                          ?._source?.paymentType ===
                                          "MEMBERSHIP" &&
                                        student?.inner_hits?.batchstudentmapping
                                          ?.hits?.hits?.[0]?._source
                                          ?.paymentStatus !==
                                          "Membership Fully Paid" ? (
                                        <>
                                          {student?.inner_hits
                                            ?.batchstudentmapping?.hits
                                            ?.hits?.[0]?._source
                                            ?.paymentStatus ===
                                            "Membership Fees Paid" ||
                                          student?.inner_hits
                                            ?.batchstudentmapping?.hits
                                            ?.hits?.[0]?._source
                                            ?.paymentStatus ===
                                            "Membership Paused" ? (
                                            <>
                                              Next Due On:{" "}
                                              {student?.inner_hits
                                                ?.batchstudentmapping?.hits
                                                ?.hits?.[0]?._source
                                                ?.paymentDetails?.nextDueOn
                                                ? moment
                                                    .unix(
                                                      student?.inner_hits
                                                        ?.batchstudentmapping
                                                        ?.hits?.hits?.[0]
                                                        ?._source
                                                        ?.paymentDetails
                                                        ?.nextDueOn / 1000
                                                    )
                                                    .format("DD/MM/YYYY")
                                                : "N/A"}
                                            </>
                                          ) : (
                                            <>
                                              Due On:{" "}
                                              {student?.inner_hits
                                                ?.batchstudentmapping?.hits
                                                ?.hits?.[0]?._source
                                                ?.paymentDetails?.dueOn
                                                ? moment
                                                    .unix(
                                                      student?.inner_hits
                                                        ?.batchstudentmapping
                                                        ?.hits?.hits?.[0]
                                                        ?._source
                                                        ?.paymentDetails
                                                        ?.dueOn / 1000
                                                    )
                                                    .format("DD/MM/YYYY")
                                                : "N/A"}
                                            </>
                                          )}
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </CustomTableCell>
                                )}
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <>
                    {studentItems?.length <= 0 &&
                    filterApplied === false &&
                    studentListLoading === false ? (
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "absolute",
                          fontSize: "14px",
                          color: "#667085",
                          fontWeight: "600",
                        }}
                      >
                        No data Available
                      </div>
                    ) : (
                      filterApplied === false && <TableSkeleton />
                    )}
                  </>
                )}

                {filterApplied === true &&
                studentItems &&
                studentItems?.length <= 0 ? (
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        textTransform: "capitalize",
                        color: "#142C44",
                      }}
                    >
                      No results found.{" "}
                      <span
                        style={{
                          color: "#667085",
                        }}
                      >
                        {filterApplied === true
                          ? "Try another filter"
                          : "Try another search"}
                      </span>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </>
          )}
        </div>
        <ClearFilter
          open={isOpenFilter}
          noButtonClick={noButtonClick}
          yesButtonClick={yesButtonClick}
          onClose={closeClearFilter}
          filteredValue={filteredValue}
        />
      </div>
    </div>
  );
}
